import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import handleOpenWhatsApp from 'services/whatsappService';
import {
  conversion,
  WHATSAPP_DEFAULT,
  WHATSAPP_PHONE,
} from '../cherrySoftwareContent';
import CheckList from './CheckList';
import IconBadge from './IconBadge';

const openWhatsApp = () => handleOpenWhatsApp(null, WHATSAPP_DEFAULT, WHATSAPP_PHONE);

const ConversionZone = () => {
  const theme = useTheme();

  return (
    <Box id="agenda" py={{ xs: 4, md: 6 }}>
      <Box
        py={{ xs: 8, md: 10 }}
        px={{ xs: 2, md: 3 }}
        textAlign="center"
        sx={{
          borderRadius: { md: 4 },
          color: 'common.white',
          position: 'relative',
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${theme.palette.primary.dark || theme.palette.primary.main} 0%, ${theme.palette.primary.main} 52%, ${alpha(theme.palette.secondary.main, 0.95)} 100%)`,
          boxShadow: `0 28px 70px ${alpha(theme.palette.primary.main, 0.28)}`,
        }}
      >
        <Box sx={{ position: 'absolute', top: -30, right: -20, opacity: 0.12 }}>
          <IconBadge icon="code" size={140} variant="soft" rounded="32px" />
        </Box>

        <Box position="relative" zIndex={1}>
          <Box display="flex" justifyContent="center" mb={2}>
            <IconBadge icon="launch" size={58} variant="soft" rounded="18px" />
          </Box>
          <Typography
            variant="overline"
            sx={{ fontWeight: 800, letterSpacing: 1.5, opacity: 0.92 }}
          >
            {conversion.overline}
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: 800, lineHeight: 1.15, mt: 1, mb: 2, maxWidth: 760, mx: 'auto' }}
          >
            {conversion.title}
          </Typography>
          <Typography
            variant="h6"
            sx={{ opacity: 0.92, lineHeight: 1.7, maxWidth: 680, mx: 'auto', mb: 3 }}
          >
            {conversion.subtitle}
          </Typography>
          <Box maxWidth={440} mx="auto" textAlign="left" mb={3}>
            <CheckList items={conversion.bullets} dense inverted />
          </Box>
          <Button
            variant="contained"
            size="large"
            startIcon={<WhatsAppIcon />}
            onClick={openWhatsApp}
            sx={{
              bgcolor: 'common.white',
              color: theme.palette.primary.main,
              px: 4,
              py: 1.5,
              fontWeight: 800,
              borderRadius: 2,
              '&:hover': { bgcolor: alpha(theme.palette.common.white, 0.92) },
            }}
          >
            {conversion.submitCta}
          </Button>
          <Box mt={5}>
            <Typography variant="subtitle2" sx={{ opacity: 0.82 }}>
              {conversion.copyright}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ConversionZone;
